import { render, staticRenderFns } from "./approveProcess.vue?vue&type=template&id=a93f4ca0&scoped=true&"
import script from "./approveProcess.vue?vue&type=script&lang=js&"
export * from "./approveProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93f4ca0",
  null
  
)

export default component.exports